import React from 'react';


export class FormGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.generateState()
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props !== prevProps) {
            this.setState(this.generateState());
        }
    }

    generateState = () => {
        return {
            id: Math.floor(100000 + Math.random() * 900000),
            color: 'main',
            value: '',
            label: null,
            placeholder: '',
            type: 'text',
            height: 'auto',
            dataAttribute: null,
            onChange: (event) => {},
            onKeyDown: (event) => {},
            buttonText: null,
            buttonOnClick: (event) => {},
            ...this.props
        };
    }

    render() {
        return (
            <div className={'imd-form-group imd-border-bottom-color-' + this.state.color}>
                <input
                    id={'imd-form-group-id-' + this.state.id}
                    className={'imd-text-' + this.state.color}
                    type={this.state.type}
                    value={this.state.value}
                    placeholder={this.state.placeholder}
                    data-attribute={this.state.dataAttribute}
                    onChange={(event) => this.state.onChange(event)}
                    onKeyDown={(event) => this.state.onKeyDown(event)}
                />

                {
                    this.state.label !== null ?
                        <label className={'imd-description imd-text-120-' + this.state.color} htmlFor={'imd-form-group-id-' + this.state.id}>{this.state.label}</label> :
                        null
                }

                {
                    this.state.buttonText !== null ?
                        <button className={'imd-text-real-white imd-bg-gradient-reverse-' + this.state.color} onClick={() => this.state.buttonOnClick()}>
                            {this.state.buttonText}
                        </button> :
                        null
                }

                <div className={'imd-decorator imd-bg-' + this.state.color} />
            </div>
        );
    }
}
